import React, { useState } from 'react';

const PageContext = React.createContext(null);
const { Provider } = PageContext;

const StateProvider = ({ children }) => {
  const [showTemplates, setShowTemplates] = useState(false);
  const [pageRef, setPageRef] = useState(null);
  const [panZoomRef, setPanZoomRef] = useState(null);
  const [isPrintDialogOpen, setPrintDialogOpen] = useState(false);
  const [resumePreview, setResumePreview] = useState(false);
  const [authPreview, setAuthPreview] = useState(false);
  const [profilePreview, setProfilePreview] = useState(false);

  return (
    <Provider
      value={{
        pageRef,
        setPageRef,
        panZoomRef,
        setPanZoomRef,
        isPrintDialogOpen,
        setPrintDialogOpen,
        showTemplates,
        setShowTemplates,
        resumePreview,
        setResumePreview,
        authPreview,
        setAuthPreview,
        profilePreview,
        setProfilePreview
      }}
    >
      {children}
    </Provider>
  );
};

export const PageProvider = StateProvider;
export const PageConsumer = PageContext.Consumer;

export default PageContext;